import { Flex } from "antd";
import { useMemo } from "react";

import { useSelectedDateSalary } from "@/features/Dashboard";
import { useProtectedUserRoleSelector } from "@/hooks/redux";
import { Header } from "@/shared/layout";
import { MainContainer } from "@/shared/layout/Layout";
import { BlockList } from "@/shared/pageComposition/BlockList";
import { Meta } from "@/shared/seo";

import { DashboardModel, getDashboardBlocks } from "./Dashboard.blocks";
import { getDashboardCapabilities } from "./Dashboard.policy";

const Dashboard = () => {
    const role = useProtectedUserRoleSelector();
    const { selectedDateSalary, setSelectedDateSalary } =
        useSelectedDateSalary();

    const model: DashboardModel = useMemo(
        () => ({
            capabilities: getDashboardCapabilities(role),
            salary: {
                selectedDateSalary,
                onSalaryDataChange: setSelectedDateSalary,
            },
        }),
        [role, selectedDateSalary, setSelectedDateSalary],
    );

    const blocks = useMemo(() => getDashboardBlocks(model), [model]);

    return (
        <>
            <Meta title="Дашборд" />
            <Header withMidnightCountdown />
            <MainContainer>
                <Flex
                    vertical
                    gap={12}
                    flex={1}
                    style={{ minHeight: 0, width: "100%" }}
                >
                    <BlockList blocks={blocks} model={model} />
                </Flex>
            </MainContainer>
        </>
    );
};

export default Dashboard;
